import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, FormSection } from 'redux-form';
import map from 'lodash/map';

import CheckboxField from '../../../shared/form-elements/checkbox';

lessRequire('modules/profile/components/forms/notification.less');

const Form = (props) => {
	const {
		handleSubmit,
		updateNotifications,
		notificationTypes,
		intl
	} = props;

	return (
		<form action="#"
			className="profile__notification clearfix"
			onSubmit={handleSubmit(formData => updateNotifications(formData))}
		>
			<div className="profile-wrap__form-field clearfix">
				<FormSection name="digest">
					<div className="profile-wrap__position-left notification">
						<label className="font-proxima-nova-semibold">{intl('Получать новости сети')}</label>
						{	map(notificationTypes, type => (
							<Field key={`1${type.id}`} name={type.id} labelText={type.text} component={CheckboxField} />
						)) }
					</div>
				</FormSection>
				<FormSection name="new_offer">
					<div className="profile-wrap__position-left notification">
						<label className="font-proxima-nova-semibold">
							{intl('Получать уведомления о новых офферах')}
						</label>
						{	map(notificationTypes, type => (
							<Field key={`2${type.id}`} name={type.id} labelText={type.text} component={CheckboxField} />
						)) }
					</div>
				</FormSection>
				<FormSection name="offer_change">
					<div className="profile-wrap__position-left notification">
						<label className="font-proxima-nova-semibold">
							{intl('Получать уведомления об изменении офферов')}
						</label>
						{	map(notificationTypes, type => (
							<Field key={`3${type.id}`} name={type.id} labelText={type.text} component={CheckboxField} />
						)) }
					</div>
				</FormSection>
				<FormSection name="new_thread">
					<div className="profile-wrap__position-left notification">
						<label className="font-proxima-nova-semibold">
							{intl('Получать уведомления о новых тикетах')}
						</label>
						{	map(notificationTypes, type => (
							<Field key={`4${type.id}`} name={type.id} labelText={type.text} component={CheckboxField} />
						)) }
					</div>
				</FormSection>
				<FormSection name="new_thread_post">
					<div className="profile-wrap__position-left notification">
						<label className="font-proxima-nova-semibold">
							{intl('Получать уведомления о новых сообщениях в тикетах')}
						</label>
						{	map(notificationTypes, type => (
							<Field key={`5${type.id}`} name={type.id} labelText={type.text} component={CheckboxField} />
						)) }
					</div>
				</FormSection>
				<FormSection name="payout_status_change">
					<div className="profile-wrap__position-left notification">
						<label className="font-proxima-nova-semibold">
							{intl('Получать уведомления о статусах выплат')}
						</label>
						{	map(notificationTypes, type => (
							<Field key={`6${type.id}`} name={type.id} labelText={type.text} component={CheckboxField} />
						)) }
					</div>
				</FormSection>
				<FormSection name="promo">
					<div className="profile-wrap__position-left notification">
						<label className="font-proxima-nova-semibold">
							{intl('Получать уведомления о промоакциях')}
						</label>
						{	map(notificationTypes, type => (
							<Field key={`7${type.id}`} name={type.id} labelText={type.text} component={CheckboxField} />
						)) }
					</div>
				</FormSection>
				<FormSection name="system_news">
					<div className="profile-wrap__position-left notification">
						<label className="font-proxima-nova-semibold">
							{intl('Получать системные уведомления')}
						</label>
						{	map(notificationTypes, type => (
							<Field key={`8${type.id}`} name={type.id} labelText={type.text} component={CheckboxField} />
						)) }
					</div>
				</FormSection>
			</div>
			<button className="button yellow-btn profile-change-btn font-proxima-nova-semibold">
				{intl('Изменить данные')}
			</button>
		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	updateNotifications: PropTypes.func,
	initialValues: PropTypes.object,
	notificationTypes: PropTypes.array,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'profileNotificationForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/forms/notification.js